/**
 * Window Film World — Product Page JavaScript
 * Handles gallery navigation, variant selection, and quantity controls.
 */

(function () {
  'use strict';

  // ---- Image Gallery ----
  var galleryImages = [];
  var currentIndex = 0;

  function initGallery() {
    var thumbs = document.querySelectorAll('.wfw-gallery__thumb');
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (img) {
        galleryImages.push(img.src.replace(/width=\d+/, 'width=900'));
      }
    });
  }

  window.gallerySelect = function (index) {
    currentIndex = index;
    var mainImg = document.getElementById('gallery-main-img');
    if (mainImg && galleryImages[index]) {
      mainImg.src = galleryImages[index];
    }
    var counter = document.getElementById('gallery-counter');
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + galleryImages.length;
    }
    // Update active thumb
    document.querySelectorAll('.wfw-gallery__thumb').forEach(function (t, i) {
      t.classList.toggle('wfw-gallery__thumb--active', i === index);
    });
  };

  window.galleryNav = function (dir) {
    var newIndex = (currentIndex + dir + galleryImages.length) % galleryImages.length;
    window.gallerySelect(newIndex);
  };

  // ---- Variant Selection ----
  window.selectVariant = function (btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var variantCompare = btn.getAttribute('data-variant-compare');
    var priceCents = parseInt(btn.getAttribute('data-variant-price-raw'), 10);
    var compareCents = parseInt(btn.getAttribute('data-variant-compare-raw'), 10) || 0;

    // Update hidden input
    var idInput = document.getElementById('variant-id');
    if (idInput) idInput.value = variantId;

    // Update compare price span without rebuilding the whole price block
    var priceEl = document.getElementById('product-price');
    if (priceEl) {
      var compareEl = priceEl.querySelector('.wfw-price__compare');
      if (compareCents > priceCents) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'wfw-price__compare';
          priceEl.querySelector('.wfw-price__current').insertAdjacentElement('afterend', compareEl);
        }
        compareEl.textContent = variantCompare;
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    // Update active state
    document.querySelectorAll('.wfw-size-btn').forEach(function (b) {
      b.classList.remove('wfw-size-btn--active');
    });
    btn.classList.add('wfw-size-btn--active');

    // Recalculate volume tier prices, current price, and save badge for the new variant
    var qty = parseInt((document.getElementById('qty-input') || {}).value, 10) || 1;
    updateVolumePricing(qty, priceCents, compareCents);
  };

  // ---- Volume Tier Selection ----
  window.selectTier = function (dot) {
    var row = dot.closest('.wfw-volume__row');
    if (!row) return;
    var min = parseInt(row.getAttribute('data-min'), 10) || 1;
    var input = document.getElementById('qty-input');
    var display = document.getElementById('qty-display');
    if (input) input.value = min;
    if (display) display.textContent = min;
    updateVolumePricing(min);
  };

  // ---- Quantity ----
  window.updateQty = function (delta) {
    var input = document.getElementById('qty-input');
    var display = document.getElementById('qty-display');
    if (!input || !display) return;
    var val = Math.max(1, parseInt(input.value, 10) + delta);
    input.value = val;
    display.textContent = val;
    updateVolumePricing(val);
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getActiveVariantPriceCents() {
    var btn = document.querySelector('.wfw-size-btn--active');
    if (btn) {
      var raw = parseInt(btn.getAttribute('data-variant-price-raw'), 10);
      if (!isNaN(raw)) return raw;
    }
    // Single-variant products have no buttons; read from the price element directly
    var priceEl = document.getElementById('product-price');
    if (priceEl) {
      var raw = parseInt(priceEl.getAttribute('data-price-cents'), 10);
      if (!isNaN(raw)) return raw;
    }
    return null;
  }

  function getActiveVariantCompareCents() {
    var btn = document.querySelector('.wfw-size-btn--active');
    if (btn) {
      var raw = parseInt(btn.getAttribute('data-variant-compare-raw'), 10);
      if (!isNaN(raw)) return raw;
    }
    // Single-variant products have no buttons; read from the price element directly
    var priceEl = document.getElementById('product-price');
    if (priceEl) {
      var raw = parseInt(priceEl.getAttribute('data-compare-cents'), 10);
      if (!isNaN(raw)) return raw;
    }
    return 0;
  }

  function updateVolumePricing(qty, priceCents, compareCents) {
    if (priceCents === undefined) priceCents = getActiveVariantPriceCents();
    if (compareCents === undefined) compareCents = getActiveVariantCompareCents();

    var activeTierCents = null;
    var rows = document.querySelectorAll('.wfw-volume__row');
    rows.forEach(function (row) {
      var min = parseInt(row.getAttribute('data-min'), 10) || 0;
      var max = parseInt(row.getAttribute('data-max'), 10) || 9999;
      var isActive = qty >= min && qty <= max;
      row.classList.toggle('wfw-volume__row--active', isActive);
      var dot = row.querySelector('.wfw-volume__dot');
      if (dot) dot.classList.toggle('wfw-volume__dot--active', isActive);
      var label = row.querySelector('.wfw-volume__row-left span');
      if (label) {
        label.style.color = isActive ? 'hsl(var(--foreground))' : '';
      }
      var priceSpan = row.querySelector('.wfw-volume__row-right > span:last-child');
      if (priceSpan) {
        if (priceCents !== null) {
          var discount = parseFloat(row.getAttribute('data-discount')) || 0;
          var discountedCents = Math.round(priceCents * (1 - discount));
          priceSpan.childNodes[0].textContent = formatMoney(discountedCents);
          if (isActive) activeTierCents = discountedCents;
        }
        priceSpan.style.color = isActive ? 'hsl(var(--foreground))' : '';
      }
    });

    if (priceCents === null) return;

    // Sync main price display
    var displayCents = activeTierCents !== null ? activeTierCents : priceCents;
    var currentEl = document.querySelector('#product-price .wfw-price__current');
    if (currentEl) currentEl.textContent = formatMoney(displayCents);

    // Update save badge
    var priceEl = document.getElementById('product-price');
    var saveEl = priceEl && priceEl.querySelector('.wfw-price__save');
    var savingsRef = compareCents > 0 ? compareCents : priceCents;
    var savingsAmount = savingsRef > displayCents ? savingsRef - displayCents : 0;
    if (savingsAmount > 0) {
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'wfw-price__save';
        priceEl.appendChild(saveEl);
      }
      saveEl.textContent = 'Save ' + formatMoney(savingsAmount);
    } else if (saveEl) {
      saveEl.remove();
    }
  }

  // ---- Init ----
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    updateVolumePricing(1);
  });
})();
